import { Endpoint } from '@/Config/api/endpoint';
import { httpClient } from '@/Config/api/httpClient.config';
import { InboxTranslationDto } from '@/Domain/api/User/dto/InboxTranslation.dto';
import { InboxTranslationRequest } from '@/Domain/api/User/request/InboxTranslation.request';
import { ApiMapper } from '@/Domain/mapper/App/Api.mapper';

export class UserOptionsApi {
  static getTranslation = (): Promise<InboxTranslationDto> =>
    httpClient.get(Endpoint.userOptions.inboxTranslation).then(ApiMapper.toResponseData);

  static changeTranslation = (data: InboxTranslationRequest): Promise<InboxTranslationDto> =>
    httpClient.put(Endpoint.userOptions.inboxTranslation, data).then(ApiMapper.toResponseData);
}
